export const emailSourceOptions = [
  { value: '', label: '-- Auto (first connected) --' },
];

export const defaultEmailConnection = {
  host: '',
  port: '587',
  encryption: 'tls',
  username: '',
  password: '',
  fromName: '',
  fromEmail: '',
};

export const defaultWhatsAppConnection = {
  phoneNumber: '',
  apiKey: '',
  businessName: '',
};

export const defaultGlobalConfig = {
  emailConnected: false,
  emailEnabled: false,
  emailSource: '',
  whatsappConnected: false,
  whatsappEnabled: false,
  whatsappPhone: '',
  defaultSendTime: '09:00',
  sendInvoiceCopyToAdmin: false,
  autoSendOnSave: false,
  smtp: { ...defaultEmailConnection },
  whatsapp: { ...defaultWhatsAppConnection },
};

export const notificationHistory = [];

export const statusFilterOptions = ['All', 'Pending', 'Sent', 'Failed'];
export const channelFilterOptions = ['All', 'Email', 'WhatsApp', 'In-App'];
export const typeFilterOptions = [
  { value: 'All', label: 'All' },
  { value: 'subscription_expiring', label: 'Subscription Expiring' },
  { value: 'subscription_expired', label: 'Subscription Expired' },
  { value: 'payment_due', label: 'Payment Pending' },
  { value: 'attendance_reminder', label: 'Absent Attendance' },
  { value: 'birthday_wish', label: 'Birthday Wish' },
  { value: 'welcome_message', label: 'Welcome Member' },
  { value: 'renewal_thanks', label: 'Renewal Thank You' },
  { value: 'locker_fee_due', label: 'Locker Fee Reminder' },
  { value: 'freeze_ending', label: 'Freeze Ending' },
  { value: 'admin_daily_summary', label: 'Daily Summary' },
  { value: 'admin_pending_payments', label: 'Pending Payments Alert' },
  { value: 'admin_expiring_soon', label: 'Expiring Soon Alert' },
  { value: 'admin_new_member', label: 'New Member Registered' },
  { value: 'admin_inactive_members', label: 'Inactive Members' },
  { value: 'admin_equipment_maintenance', label: 'Equipment Maintenance' },
];

export const memberReminders = [
  {
    id: 'subscription_expiring',
    label: 'Subscription Expiring',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 7,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: true,
    template:
      'Hi {member_name}, your {gym_name} subscription expires on {expiry_date}. Renew today to avoid interruption!',
  },
  {
    id: 'subscription_expired',
    label: 'Subscription Expired',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 0,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: false,
    template: 'Hi {member_name}, your {gym_name} subscription has expired. Renew now to regain access.',
  },
  {
    id: 'payment_due',
    label: 'Payment Pending',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 3,
    sendTime: '10:00',
    inAppLog: true,
    hasDaysBefore: true,
    template: 'Hi {member_name}, your payment of {amount} is pending. Please settle at the front desk.',
  },
  {
    id: 'attendance_reminder',
    label: 'Absent Attendance',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 7,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: true,
    template: 'Hi {member_name}, we have not seen you at {gym_name} in {days_absent} days. Come back and stay on track!',
  },
  {
    id: 'birthday_wish',
    label: 'Birthday Wish',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 0,
    sendTime: '08:00',
    inAppLog: true,
    hasDaysBefore: false,
    template: 'Happy Birthday {member_name}! Wishing you a great day from everyone at {gym_name}.',
  },
  {
    id: 'welcome_message',
    label: 'Welcome Member',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 0,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: false,
    template: 'Welcome to {gym_name}, {member_name}! We are excited to have you on board.',
  },
  {
    id: 'renewal_thanks',
    label: 'Renewal Thank You',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 0,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: false,
    template: 'Thank you {member_name} for renewing your membership at {gym_name}. See you at the gym!',
  },
  {
    id: 'locker_fee_due',
    label: 'Locker Fee Reminder',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 5,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: true,
    template: 'Hi {member_name}, your locker fee is due on {due_date}. Renew to keep locker {locker_id}.',
  },
  {
    id: 'freeze_ending',
    label: 'Freeze Ending',
    enabled: false,
    email: true,
    whatsapp: true,
    daysBefore: 2,
    sendTime: '09:00',
    inAppLog: true,
    hasDaysBefore: true,
    template: 'Hi {member_name}, your membership freeze ends on {freeze_end_date}. Your access resumes automatically.',
  },
];
